import * as actions from './message.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ChatMessageModel } from '@smarttask-common/src/lib/models/Chat/Message/Core/ChatMessageModel';

export const messageAdapter = createEntityAdapter<ChatMessageModel>({
    selectId: (x) => x.message_id,
});
export interface ChatMessageState extends EntityState<ChatMessageModel> {
    selected_message_id: string;
}

export const initialState: ChatMessageState = messageAdapter.getInitialState({
    selected_message_id: undefined,
});

export function ChatMessageReducers(
    state: ChatMessageState = initialState,
    action: actions.ChatMessageActions
) {
    switch (action.type) {
        case actions.ChatMessageActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_message_id: action.selected_message_id };
            //console.log(state);
            return state;

        case actions.ChatMessageActionTypes.ADD_MESSAGE:
            return messageAdapter.addOne(action.message, state);

        case actions.ChatMessageActionTypes.ADD_MESSAGES:
            return messageAdapter.addMany(action.messages, state);

        case actions.ChatMessageActionTypes.UPSERT_MESSAGE:
            return messageAdapter.upsertOne(action.message, state);

        case actions.ChatMessageActionTypes.UPSERT_MESSAGES:
            return messageAdapter.upsertMany(action.messages, state);

        case actions.ChatMessageActionTypes.UPDATE_MESSAGE:
            return messageAdapter.updateOne(action.message, state);

        case actions.ChatMessageActionTypes.UPDATE_MESSAGES:
            return messageAdapter.updateMany(action.messages, state);

        case actions.ChatMessageActionTypes.DELETE_MESSAGE:
            // if(state.selectedChatMessageId == action.id){
            //   state.selectedChatMessageId = undefined;
            // }
            return messageAdapter.removeOne(action.id, state);

        case actions.ChatMessageActionTypes.DELETE_MESSAGES:
            // if(action.ids.indexOf(state.selectedChatMessageId) > -1){
            //   state.selectedChatMessageId = undefined;
            // }
            return messageAdapter.removeMany(action.ids, state);

        case actions.ChatMessageActionTypes.DELETE_ALL_MESSAGES:
            return messageAdapter.removeMany(action.ids, state);

        case actions.ChatMessageActionTypes.DELETE_ALL:
            return messageAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getChatMessageState = createFeatureSelector<ChatMessageState>('chatMessage');

export const { selectIds, selectEntities, selectAll, selectTotal } =
    messageAdapter.getSelectors(getChatMessageState);

const getSelectedChatMessageIdState = (state: ChatMessageState) => {
    return state.selected_message_id;
};
export const getSelectedChatMessageId = createSelector(getChatMessageState, getSelectedChatMessageIdState);

export const getSelectedChatMessage = createSelector(getChatMessageState, (state: ChatMessageState) => {
    if (state.selected_message_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_message_id];
});
